export default __webpack_public_path__ + "static/media/me.24fb4027.jpeg";